import { HorseContactModel } from '../../../../types/HorseContact';
import { DBWriterLoggerFunction } from '../../../../types/logger';

export const prepareDeleteHorseContact = ({
    horseContact,
}: {
    horseContact: HorseContactModel;
}) => horseContact.prepareMarkAsDeleted();

export const logDeleteHorseContactAction = ({
    horseContact,
    logDBAction,
    tableName,
}: {
    horseContact: HorseContactModel;
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Delete horse contact',
        modelName: tableName,
        payload: horseContact,
    });
};
